import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-36">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-37">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-38">
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-39">
              <h3 className="text-xl font-serif font-bold text-gray-900" data-id="element-40">
                {title}
              </h3>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-41">
                <XIcon className="w-5 h-5 text-gray-500" data-id="element-42" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-gray-700 text-sm leading-relaxed space-y-4" data-id="element-43">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-gray-900 text-gray-400 py-12 px-6 text-center text-sm" data-id="element-44">
        <div className="max-w-4xl mx-auto" data-id="element-45">
          <h4 className="text-xl font-serif font-bold text-white mb-4" data-id="element-46">
            Metabolismo 40+ Reset
          </h4>
          <p className="mb-6" data-id="element-47">
            © {new Date().getFullYear()} Todos los derechos reservados.
          </p>

          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-48">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-white transition-colors underline underline-offset-2" data-id="element-49">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-50">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-white transition-colors underline underline-offset-2" data-id="element-51">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-xs text-gray-500 max-w-2xl mx-auto leading-relaxed" data-id="element-52">
            Descargo de responsabilidad: Este es un producto digital. La
            información proporcionada en este sitio web y en el producto no
            pretende sustituir el consejo médico profesional, el diagnóstico o
            el tratamiento. Siempre busque el consejo de su médico u otro
            proveedor de salud calificado con cualquier pregunta que pueda tener
            con respecto a una condición médica.
          </p>
        </div>
      </footer>

      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-53">
        <p data-id="element-54">
          <strong data-id="element-55">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-56">
          En Metabolismo 40+ Reset, nos comprometemos a proteger su privacidad.
          Esta política describe cómo recopilamos, usamos y protegemos su
          información personal.
        </p>
        <h4 className="font-bold text-gray-900 mt-4" data-id="element-57">
          1. Información que Recopilamos
        </h4>
        <p data-id="element-58">
          Recopilamos información que usted nos proporciona directamente al
          realizar una compra, como su nombre, dirección de correo electrónico e
          información de pago. No almacenamos datos de tarjetas de crédito
          directamente; estos son procesados de forma segura por nuestro
          proveedor de pagos.
        </p>
        <h4 className="font-bold text-gray-900 mt-4" data-id="element-59">
          2. Uso de la Información
        </h4>
        <p data-id="element-60">
          Utilizamos su información para procesar su pedido, enviarle el
          producto digital adquirido y comunicarnos con usted sobre su compra.
          No vendemos, alquilamos ni compartimos su información personal con
          terceros con fines de marketing.
        </p>
        <h4 className="font-bold text-gray-900 mt-4" data-id="element-61">3. Protección de Datos</h4>
        <p data-id="element-62">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger su información personal contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>
        <h4 className="font-bold text-gray-900 mt-4" data-id="element-63">4. Cookies</h4>
        <p data-id="element-64">
          Nuestro sitio web puede utilizar cookies para mejorar su experiencia
          de navegación y analizar el tráfico del sitio. Puede configurar su
          navegador para rechazar cookies, aunque esto puede afectar la
          funcionalidad del sitio.
        </p>
        <h4 className="font-bold text-gray-900 mt-4" data-id="element-65">5. Sus Derechos</h4>
        <p data-id="element-66">
          Usted tiene derecho a acceder, corregir o eliminar su información
          personal. Para ejercer estos derechos, puede contactarnos a través de
          los canales indicados en nuestro sitio web.
        </p>
      </Modal>

      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-67">
        <p data-id="element-68">
          <strong data-id="element-69">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-70">
          Al acceder y utilizar este sitio web y adquirir nuestros productos,
          usted acepta estos términos y condiciones en su totalidad.
        </p>
        <h4 className="font-bold text-gray-900 mt-4" data-id="element-71">1. Producto Digital</h4>
        <p data-id="element-72">
          Metabolismo 40+ Reset es un producto digital de información. Al
          completar su compra, recibirá acceso inmediato al contenido digital.
          Debido a la naturaleza del producto, no se aceptan devoluciones una
          vez entregado el acceso.
        </p>
        <h4 className="font-bold text-gray-900 mt-4" data-id="element-73">2. Uso del Producto</h4>
        <p data-id="element-74">
          El contenido adquirido es para uso personal y no comercial. Queda
          prohibida la reproducción, distribución o reventa del material sin
          autorización expresa por escrito.
        </p>
        <h4 className="font-bold text-gray-900 mt-4" data-id="element-75">
          3. Descargo de Responsabilidad Médica
        </h4>
        <p data-id="element-76">
          La información contenida en este producto es solo para fines
          educativos e informativos. No constituye consejo médico, diagnóstico
          ni tratamiento. Consulte siempre a un profesional de la salud
          calificado antes de comenzar cualquier programa de alimentación o
          ejercicio.
        </p>
        <h4 className="font-bold text-gray-900 mt-4" data-id="element-77">4. Resultados</h4>
        <p data-id="element-78">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos, ya que estos dependen de múltiples factores
          individuales como la adherencia al programa, condiciones de salud
          preexistentes y estilo de vida.
        </p>
        <h4 className="font-bold text-gray-900 mt-4" data-id="element-79">
          5. Propiedad Intelectual
        </h4>
        <p data-id="element-80">
          Todo el contenido, diseño, textos, gráficos y materiales de este sitio
          web y producto son propiedad de Metabolismo 40+ Reset y están
          protegidos por las leyes de propiedad intelectual aplicables.
        </p>
        <h4 className="font-bold text-gray-900 mt-4" data-id="element-81">6. Modificaciones</h4>
        <p data-id="element-82">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor inmediatamente después
          de su publicación en el sitio web.
        </p>
      </Modal>
    </>;
}